__turbopack_context__.v({
  "actionIsDisabled": "page-module-scss-module__edczKa__actionIsDisabled",
  "badge": "page-module-scss-module__edczKa__badge",
  "clearfix": "page-module-scss-module__edczKa__clearfix",
  "isActiveNavLink": "page-module-scss-module__edczKa__isActiveNavLink",
  "isDisabledNavLink": "page-module-scss-module__edczKa__isDisabledNavLink",
  "pageHeader": "page-module-scss-module__edczKa__pageHeader",
  "pageHeaderActions": "page-module-scss-module__edczKa__pageHeaderActions",
  "pageHeaderActionsWrapper": "page-module-scss-module__edczKa__pageHeaderActionsWrapper",
  "pageHeaderTitle": "page-module-scss-module__edczKa__pageHeaderTitle",
  "pageHeaderWithActions": "page-module-scss-module__edczKa__pageHeaderWithActions",
  "pageNavigation": "page-module-scss-module__edczKa__pageNavigation",
  "pageNavigationActions": "page-module-scss-module__edczKa__pageNavigationActions",
  "pageNavigationLinks": "page-module-scss-module__edczKa__pageNavigationLinks",
  "separator": "page-module-scss-module__edczKa__separator",
});
